import { render, staticRenderFns } from "./History.vue?vue&type=template&id=e94bc312&"
import script from "./History.vue?vue&type=script&lang=js&"
export * from "./History.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3001884671/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e94bc312')) {
      api.createRecord('e94bc312', component.options)
    } else {
      api.reload('e94bc312', component.options)
    }
    module.hot.accept("./History.vue?vue&type=template&id=e94bc312&", function () {
      api.rerender('e94bc312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/History.vue"
export default component.exports